import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-experience',
  templateUrl: './experience.component.html',
  styleUrls: ['./experience.component.scss']
})
export class ExperienceComponent implements OnInit {

  public workExperiences = {
    viewExperiences: true,
    experience: [
      {
        role: "Angular Developer",
        company: "Ariqt International",
        color: "#3781c2",
        companylogo: "../../../assets/images/ariqtLogo.jpg",
        date: "2021-2023",
        // desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        desc: "Associate Angular developer focoused on design and development",
        // descBullets: [
        //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
        // ]
      },
      {
        role: "Electronics and Communication Engineering",
        company: "BVRIT",
        color: "#3f703f",
        companylogo: "../../../assets/images/gla.png",
        date: "Aug 2012 – Jul 2016",
        desc: "I have completed my 4 year graduation in electronics and communication",
        // descBullets: [
        //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
        // ]
      },
      {
        role: "Software Engineer",
        company: "Freelancer",
        color: "#ff9102",
        companylogo: "../../../assets/images/ibs.jpg",
        date: "Jun 2018 – Aug 2018",
        desc: "This 1 year worked on different e-commerce sites, clients based India and Europe",
        },
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    ]
  };

  constructor() { }

  ngOnInit(): void {
  }

}
